import React from 'react';
import moment from 'moment';
import cn from 'classnames';

import { DATE_TIME_FORMAT } from '../../../constants';

import styles from './styles.module.scss';

const QuickPortData = ({ portData }) => {
  const {
    carrier_account,
    carrier_password,
    created_at,
    csa,
    external_port_message,
    external_port_number,
    first_name,
    last_name,
    mdn,
    status,
    updated_at,
  } = portData;
  return (
    <div>
      <h3>Port Data</h3>
      <table className={cn('table', styles.table)}>
        <tbody>
          <tr>
            <th>First Name</th>
            <td>{first_name}</td>
          </tr>
          <tr>
            <th>Last Name</th>
            <td>{last_name}</td>
          </tr>
          <tr>
            <th>MDN</th>
            <td>{mdn}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td>{status}</td>
          </tr>
          <tr>
            <th>Carrier Account</th>
            <td>{carrier_account}</td>
          </tr>
          <tr>
            <th>Carrier Password</th>
            <td>{carrier_password}</td>
          </tr>
          <tr>
            <th>Created At</th>
            <td>
              {created_at
                ? moment(created_at).format(DATE_TIME_FORMAT)
                : created_at}
            </td>
          </tr>
          <tr>
            <th>Update At</th>
            <td>
              {updated_at
                ? moment(updated_at).format(DATE_TIME_FORMAT)
                : updated_at}
            </td>
          </tr>
          <tr>
            <th>CSA</th>
            <td>{csa}</td>
          </tr>
          <tr>
            <th>External Port Message</th>
            <td>{external_port_message}</td>
          </tr>
          <tr>
            <th>External Port Number</th>
            <td>{external_port_number}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default QuickPortData;
